import { MODULE_KEYS } from './moduleKeys';

export const ROUTE_MODULE_MAP = {
  '/rentals': MODULE_KEYS.RENTALS,
  '/bookings': MODULE_KEYS.BOOKINGS,
  '/sales': MODULE_KEYS.SALES,
  '/inventory': MODULE_KEYS.INVENTORY,
  '/customers': MODULE_KEYS.CUSTOMERS,
  '/payments': MODULE_KEYS.PAYMENTS,
  '/maintenance': MODULE_KEYS.MAINTENANCE,
  '/returns': MODULE_KEYS.RETURNS,
  '/pos': MODULE_KEYS.POS,
  '/categories': MODULE_KEYS.CATEGORIES,
  '/expenses': MODULE_KEYS.EXPENSES,
  '/analytics': MODULE_KEYS.ANALYTICS,
};
